export default "__VITE_ASSET__BtoLlJHa__"